<template>
  <section>
    <VerReporte />
    <AbrirCerrarTipificacionDia />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-flex xs12 >
      <v-btn
        dark
        color="light-blue darken-3"
        :to="`/asistencia-tipificacion`"
        title="Volver"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn></v-flex
    >
    <v-card>
      <v-card-title class="headline">
        <v-icon> build </v-icon>
        Ajuste procesamiento de control de asistencia
      </v-card-title>
      <v-card-text>
        <DatosPersonales :id_persona="this.id_persona" />
      </v-card-text>
      <v-card-text class="py-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              class="text-field-reducido-border"
              type="date"
              v-model="form.fecha"
              label="Fecha marcado"
              :rules="$validate(['required'])"
              required
              outline
              clearable
              @change="actualizarDatos()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text class="py-0">
        <v-layout row wrap align-center justify-space-between>
          <v-flex xs6>
            <v-tooltip>
              <v-btn
                dark
                slot="activator"
                @click.native="actualizarDatos()"
                color="light-blue darken-3"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Recargar listado</span>
            </v-tooltip></v-flex
          >
          <v-flex xs6 class="text-xs-right">
            <v-btn
              dark
              color="light-blue darken-3"
              @click.prevent="verReporte()"
              title="Ver reporte de asistencia del funcionario"
            >
              <v-icon>picture_as_pdf</v-icon>
            </v-btn></v-flex
          >
          <v-flex shrink>
            <b class="blue--text">DIA: </b>{{ asistencia.dia }}</v-flex
          >
          <v-flex shrink>
            <v-btn
              dark
              slot="activator"
              color="indigo"
              large
              outline
              :title="cierre_control.cerrado ? 'Abrir día' : 'Cerrar día'"
              @click.native="abrirCerrarDia()"
              :disabled="asistencia.marcados.length == 0"
            >
              <v-icon large>{{
                cierre_control.cerrado ? "lock" : "lock_open "
              }}</v-icon>
            </v-btn>
          </v-flex>
          <v-flex shrink
            ><b class="blue--text">TOTAL MINUTOS ATRASO DIA: </b
            >{{
              parseInt(
                asistencia.marcados.reduce(
                  (acumulador, marcado) => acumulador + marcado.atraso,
                  0
                )
              )
            }}</v-flex
          >
        </v-layout>
        <v-layout row wrap v-if="loading === true">
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular
              slot="activator"
              indeterminate
              color="light-blue darken-3"
              size="90"
              width="7"
            ></v-progress-circular
          ></v-flex>
        </v-layout>
        <v-layout row v-else>
          <v-flex grow>
            <table class="table-marcado">
              <tr>
                <th>Horario</th>
                <th>Tolerancia</th>
                <th>Marcado</th>
                <th>Atraso</th>
                <th>Descripción</th>
                <th>Clasificación</th>
              </tr>
              <tr
                v-for="marcado in asistencia.marcados"
                :key="marcado.id_control_asistencia"
                :style="
                  marcado.atraso > 0
                    ? 'background:rgb(219, 62, 177,0.3'
                    : marcado.tipo_marcado == 'I'
                    ? 'background:rgb(252, 76, 2,0.3'
                    : ''
                "
              >
                <td style="width: 10%;">
                  {{ marcado.horario }}
                </td>
                <td style="width: 10%;">{{ marcado.tolerancia }}</td>
                <td style="width: 10%">
                  {{ marcado.hora_marcada ? marcado.hora_marcada : "-" }}
                </td>
                <td style="width: 10%">
                  <v-text-field
                    v-if="
                      marcado.tipo_marcado == 'A' && !cierre_control.cerrado
                    "
                    class="text-field-reducido text-xs-center"
                    style="text-align: center"
                    type="number"
                    v-model.number="marcado.atraso"
                    hide-details
                    single-line
                  ></v-text-field>
                  <span v-else>{{ marcado.atraso }}</span>
                </td>
                <td style="width: 45%; font-size:0.9em">
                  <v-tooltip bottom color="indigo lighten-1">
                    <span slot="activator">{{ marcado.descripcion_caso }}</span>
                    <span style="font-size:1.3em">
                      {{ marcado.descripcion_caso }}</span
                    >
                  </v-tooltip>
                </td>
                <td style="width: 25%;">
                  <v-autocomplete
                    :disabled="cierre_control.cerrado"
                    class="text-field-reducido"
                    solo
                    :items="l_tipos_marcado"
                    item-text="descripcion"
                    item-value="valor"
                    label="Tipo de marcado"
                    v-model="marcado.tipo_marcado"
                    required
                    hide-details
                  ></v-autocomplete>
                </td>
              </tr>
              <tr v-if="asistencia.marcados.length == 0">
                <td colspan="6"><b>NO CUENTA CON MARCADOS</b></td>
              </tr>
            </table>
          </v-flex>
          <v-flex
            xs2
            style="background:rgba(0, 175, 215,0.1)"
            v-if="asistencia.marcados.length > 0 && !cierre_control.cerrado"
          >
            <table class="table-marcado-drag">
              <tr>
                <th>MARCADO</th>
              </tr>
              <tr>
                <VueDraggable
                  :list="asistencia.marcados_drag"
                  :options="{ group: 'a', animation: 150 }"
                  :no-transition-on-drag="true"
                  @start="drag = true"
                  @end="drag = false"
                  class="list-wrapper__dragarea"
                >
                  <transition-group
                    :name="!drag ? 'list-complete' : null"
                    :css="true"
                  >
                    <div
                      v-for="marcado in asistencia.marcados_drag"
                      :key="marcado.id_control_asistencia"
                      class="div-list align-center d-flex"
                    >
                      <span>{{ marcado.hora_marcada }}</span>
                    </div>
                  </transition-group>
                </VueDraggable>
              </tr>
            </table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="#0076A8"
          @click="guardarAjuste()"
          title="Guardar ajustes"
          dark
          block
          :disabled="
            cierre_control.cerrado || this.asistencia.marcados.length == 0
          "
        >
          <v-icon>save</v-icon>GUARDAR AJUSTE
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <v-card>
      <v-expansion-panel popout>
        <v-expansion-panel-content style="background:#006298">
          <template v-slot:actions>
            <v-icon color="white">$vuetify.icons.expand</v-icon>
          </template>
          <template v-slot:header>
            <div class="text-xs-center white--text">SEGUIMIENTO</div>
          </template>
          <v-card>
            <SeguimientoTipificacion
              :fecha_marcado="form.fecha"
              :id_persona="id_persona"
              :key="key_actualizacion"
            />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>
    <v-divider></v-divider>
    <v-card>
      <v-expansion-panel popout>
        <v-expansion-panel-content style="background:#00838F">
          <template v-slot:actions>
            <v-icon color="white">$vuetify.icons.expand</v-icon>
          </template>
          <template v-slot:header>
            <div class="text-xs-center white--text">HISTORICO AJUSTES</div>
          </template>
          <v-card>
            <HistoricoAjustes
              :fecha_marcado="form.fecha"
              :id_persona="id_persona"
              :key="key_actualizacion"
            />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import DatosPersonales from "./components/DatosPersonales.vue";

import VueDraggable from "vuedraggable";
import AbrirCerrarTipificacionDia from "./dialogs/AbrirCerrarTipificacionDia.vue";
import SeguimientoTipificacion from "./components/SeguimientoTipificacion.vue";
import HistoricoAjustes from "./components/HistoricoAjustes.vue";
import VerReporte from "./dialogs/VerReporte";

export default {
  components: {
    VueDraggable,
    DatosPersonales,
    AbrirCerrarTipificacionDia,
    SeguimientoTipificacion,
    HistoricoAjustes,
    VerReporte
  },
  mixins: [validate],
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      valid: false,
      form: {
        fecha: this.$moment().format("YYYY-MM-DD")
      },
      loading: false,
      id_persona: parseInt(this.$route.params.id_persona),
      user: this.$storage.get("user"),
      drag: false,
      asistencia: {
        marcados: [],
        marcados_drag: []
      },
      // { descripcion_caso: "SIN MARCADOS", id_control_asistencia: -1 }
      headers: [
        {
          text: "Horario",
          sortable: false,
          value: "Horario",
          sortable: false,
          align: "center"
        },
        {
          text: "Marcado",
          sortable: false,
          value: "Marcado",
          sortable: false,
          align: "center"
        },
        {
          text: "Atraso",
          sortable: false,
          value: "Atraso",
          sortable: false,
          align: "center"
        },
        {
          text: "Descripción",
          sortable: false,
          value: "Atraso",
          sortable: false,
          align: "center"
        }
      ],
      l_tipos_marcado: [],
      cierre_control: { cerrado: true },
      key_actualizacion: 0
    };
  },
  watch: {},
  async mounted() {
    this.$bus.$on("closeDialogAbrirCerrarTipificacionDia", async () => {
      await this.actualizarDatos();
      this.key_actualizacion += 1;
    });
    this.form.fecha = this.$moment().format("YYYY-MM-DD");
    await this.obtenerTIpoMarcados();
    await this.actualizarDatos();
  },
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async actualizarDatos() {
      await this.obtenerAsistenciasTipificadas();
      await this.verificaCierreDia();
    },
    // Metodo para ver el reporte de asistencia
    verReporte() {
      let url;
      let nombre_reporte = "";
      let formato_doc = "output=pdf";
      let nombre_carpeta = "marcados";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url_parametros = null;
      //reporte de aistencias por funcionario
      nombre_reporte = "rpt_asistencia_general2";
      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      //Parametros
      // URL con parametros
      url_parametros = `${url}&fecha_inicio=${this.form.fecha}&fecha_fin=${this.form.fecha}&id_persona=${this.id_persona}`;
      console.log(url_parametros);
      this.$bus.$emit("openDialogVerReporte", url_parametros);
    },
    // Metodo para obtener los marcados del dia
    async obtenerAsistenciasTipificadas() {
      try {
        this.loading = true;
        if (this.form.fecha) {
          let rpta = await this.$service.graphql({
            query: `
            query{
              getMarcadosTipificado(id_persona:${this.id_persona},fecha_desde:"${this.form.fecha}",fecha_hasta:"${this.form.fecha}"){
                rows{
                  fecha_marcado
                  dia
                  atraso
                  marcados{
                    id_control_asistencia
                    hora_marcada
                    horario
                    descripcion_caso
                    atraso
                    tolerancia
                    tipo_marcado
                    detalle_marcado
                    marcado_manual
                  }
                }
              }
            }
            `
          });
          if (rpta.getMarcadosTipificado.rows[0]) {
            this.asistencia = rpta.getMarcadosTipificado.rows[0];
            this.asistencia.marcados_drag = JSON.parse(
              JSON.stringify(this.asistencia.marcados)
            );
          }
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para obtner los ditintos tipos de marcados
    async obtenerTIpoMarcados() {
      try {
        this.loading = true;
        if (this.form.fecha) {
          let rpta = await this.$service.graphql({
            query: `
              query{
                parametrosPlanillas(tipo:"CLASIFICACION_MARCADO",id_estado:1){
                  rows{
                    tipo
                    valor
                    descripcion
                  }
                }
              }
            `
          });
          this.l_tipos_marcado = rpta.parametrosPlanillas.rows;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para cerrar o abrir el dia de tipificado
    async abrirCerrarDia() {
      this.$bus.$emit("openDialogAbrirCerrarTipificacionDia", {
        cierre: this.cierre_control.cerrado ? false : true,
        marcados: [],
        fecha_marcado: this.form.fecha,
        id_persona: this.id_persona,
        titulo_dialog: `${
          this.cierre_control.cerrado ? "ABRIR DÍA" : "CERRAR DIA"
        }`
      });
    },
    // Metodo para guardar el ajuste y abrir el dialog, en este metodo armamos los marcados modificados
    async guardarAjuste() {
      try {
        // Damos formato al vector de marcados
        var data_marcados = JSON.parse(
          JSON.stringify(this.asistencia.marcados)
        );
        for (let index = 0; index < data_marcados.length; index++) {
          const element = data_marcados[index];
          // Asignamos el marcado movido segun la posicion del vector
          element.hora_marcada = this.asistencia.marcados_drag[
            index
          ].hora_marcada;
          element.marcado_manual = this.asistencia.marcados_drag[
            index
          ].marcado_manual;
          // Asignamos el detalle de marcado, excluimos los tipos que no se deben guardar
          element.detalle_marcado = ["HN", "I", "HE", "CP"].includes(
            element.tipo_marcado
          )
            ? null
            : this.l_tipos_marcado.find(
                tipo => tipo.valor == element.tipo_marcado
              ).descripcion;
        }
        this.$bus.$emit("openDialogAbrirCerrarTipificacionDia", {
          cierre: true,
          marcados: data_marcados,
          fecha_marcado: this.form.fecha,
          id_persona: this.id_persona,
          titulo_dialog: `GUARDAR AJUSTE TIPIFICACIÓN`
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para verifcar si el dia esta cerrado o no
    async verificaCierreDia() {
      try {
        let rpta = await this.$service.graphql({
          query: `
             query{
              cierreControlAsistencias(id_persona:${this.id_persona},fecha_marcado:"${this.form.fecha}"){
                rows{
                  id
                  fecha_marcado
                  cerrado
                }
              }
            }
            `
        });
        if (rpta.cierreControlAsistencias.rows.length > 0) {
          this.cierre_control = rpta.cierreControlAsistencias.rows[0];
        } else {
          this.cierre_control = { cerrado: false };
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.list-wrapper__dragarea {
  // min-height: 100px;
  text-align: center;
}
.table-marcado {
  min-width: 100%;
  border-spacing: 0;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      border: 1px solid rgba(2, 69, 156, 0.2);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      border: 1px solid rgba(2, 69, 156, 0.2);
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 4.2em !important;
      max-width: 100px;
      overflow: hidden;
      padding: 0.5em 0.2em 0.5em 0.2em !important;
    }
  }
}
.table-marcado-drag {
  min-width: 100%;
  border-spacing: 0;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      border: 1px solid rgba(2, 69, 156, 0.2);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    .div-list {
      border: 1px solid rgba(2, 69, 156, 0.2);
      height: 4.2em !important;
      padding: 0.5em 0.2em 0.5em 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tipificacion/AjusteTipificacion.vue